import { showError, showLoading, updateLoading, showSuccess } from '../utils/showPopup'
import { resizeFileTo256JPEG } from "./ImageResize"
import { getFormHeaders } from "./util/getRequestHeaders";

export const useRegister = () => {
    const register = async (full_name, email, date_birth, phone_number, image, membership_type, membership_months, groups, membership_date, rfid) => {
        const define_membership = (membership_type) => {
            switch (membership_type) {
                case "2xtjedno":
                    return {
                        type: "2xtjedno",
                        weekly: 2,
                        remaining: 2,
                        strict_visit: false
                    }
                case "3xtjedno":
                    return {
                        type: "3xtjedno",
                        weekly: 3,
                        remaining: 3,
                        strict_visit: false
                    }
                case "neograniceno":
                    return {
                        type: "neograniceno",
                        weekly: -1,
                        remaining: -1,
                        strict_visit: false
                    }
                case "jutarnja":
                    return {
                        type: "jutarnja",
                        weekly: -1,
                        remaining: -1,
                        strict_visit: true
                    }
            }
        }
        const data = new FormData();
        let identifier = Math.floor(Date.now())
        data.append("name", full_name)
        data.append("email", email || `Email nedostaje (${identifier})`)
        data.append("date_birth", date_birth)
        data.append("phone_number", phone_number || `Broj nedostaje (${identifier})`)
        data.append("membership_type", JSON.stringify(define_membership(membership_type)))
        if (membership_months) {
            data.append("membership_months", membership_months)
        }
        if (membership_date) {
            data.append("membership_date", membership_date)
        }
        data.append("groups", JSON.stringify(groups))
        if (rfid) {
            data.append("rfid", rfid)
        }
        showLoading("Kreiramo korisnika...", "useRegister")

        if (image == "") {
            updateLoading("useRegister", "Molimo vas dodajte sliku!", showError)
            return
        }

        await resizeFileTo256JPEG(image).then((resizedFile) => {
            data.append("image", resizedFile)
        })

        const response = await fetch("/api/gym/register", {
            method: "POST",
            headers: getFormHeaders(),
            body: data
        })

        const json = await response.json()

        if (!response.ok) {
            updateLoading("useRegister", json.error, showError)
        } else if (response.ok) {
            updateLoading("useRegister", `Korisnik ${full_name} uspješno kreiran.`, showSuccess)
            return true
        }
    }

    return { register }
}